import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

const TiptapActiveEditorContext = createContext(null);

/**
 * Lets a nested TipTap instance (e.g. carousel caption) temporarily become the
 * target of the shared post toolbar while focused.
 */
export function TiptapActiveEditorProvider({ mainEditor, children }) {
  const [activeOverlayEditor, setActiveOverlayEditorState] = useState(null);

  const setActiveOverlayEditor = useCallback((ed) => {
    setActiveOverlayEditorState(ed || null);
  }, []);

  const value = useMemo(
    () => ({
      mainEditor,
      activeOverlayEditor,
      setActiveOverlayEditor,
    }),
    [mainEditor, activeOverlayEditor, setActiveOverlayEditor]
  );

  return (
    <TiptapActiveEditorContext.Provider value={value}>{children}</TiptapActiveEditorContext.Provider>
  );
}

export function useTiptapActiveEditor() {
  return useContext(TiptapActiveEditorContext);
}
